import { z } from "zod";

export const host = z.enum([
  //
  "getgpt.app",
  "nextrows.com",
]);

export type Host = z.infer<typeof host>;

export const HOST = {
  "getgpt.app": {
    ga: "G-H5FQ32PEKX",
    clarity: "pxfbvv7dpt",
    posthog: null,
    cf: "67fec8d40d7a4e3a8b707fb2559e0105",
    amplitude: "a8fcc6126a1608bae1d1bba511716374",
    vercel: true,
  },
  "nextrows.com": {
    ga: "G-5494YJZ24N",
    clarity: "q4lzp2sew2",
    posthog: "phc_SExhPpPcQWMbl9IOXvtPSiq9L6IFFuv92QWr01vOMTM",
    cf: `e7ab20a915c64b8ba3a25f34b0a6bc7c`,
    amplitude: "7fe25f8cebabc0e0e01bdd576652915d",
    vercel: true,
  },
} as const;
